import { render } from "./remoteView.vue?vue&type=template&id=5da900d8"
import script from "./remoteView.vue?vue&type=script&lang=js"
export * from "./remoteView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__